import React from 'react';
import {Flex, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {highlightText} from '../../../../_legacy/library/utils/highlightText';
import {isRTL} from '../../../../Localization';

type SubformItemProps = {
    isOpen: boolean;
    isDisabled: boolean;
    title: string;
    searchQuery: string;
};

export const SubformItem = ({isOpen, isDisabled, title, searchQuery}: SubformItemProps) => {
    return (
        <>
            <Flex
                justifyContent="flex-start"
                alignItems="center"
                componentClasses={styles.subFormItemTitle}
            >
                <Icon
                    iconColor="primary-700"
                    componentClasses={!isOpen && styles.arrowIcon}
                    icon={
                        isOpen
                            ? PriorityIcon.arrowBottom
                            : isRTL()
                            ? PriorityIcon.arrowLeft
                            : PriorityIcon.arrowRight
                    }
                    disabled={isDisabled}
                />
                <Text textColor={isDisabled ? 'secondary-200' : 'primary-700'} skin="paragraph-2">
                    {highlightText(title.replace('(ID)', ''), searchQuery, true, false, true)}
                </Text>
            </Flex>
        </>
    );
};
